import notify from './notify';

/* global jQuery, APP */

export function request(options) {
  const normalizedUrl = (options.url.indexOf('http') === -1 ? APP.REST_API_BASE : '') + options.url;

  jQuery.ajax({
    url: normalizedUrl,
    type: options.method,
    data: {
      ...(options.data || {}),
      _wp_http_referer: APP.REFERER,
      _wpnonce: APP.WP_REST_NONCE,
      nonce: APP.NONCE,
    },
    success: options.success
      ? (data, textStatus, jqXHR) => options.success(jqXHR, textStatus)
      : null,
    error: options.error || null,
    complete: (jqXHR, textStatus) => {
      updateNonce(jqXHR.responseText);

      if (jqXHR.responseJSON && jqXHR.responseJSON.success && jqXHR.responseJSON.message) {
        notify(jqXHR.responseJSON.message);
      }

      if (jqXHR.responseJSON && !jqXHR.responseJSON.success && jqXHR.responseJSON.message) {
        notify(jqXHR.responseJSON.message, 'danger');
      }

      if (textStatus === 'error' && !jqXHR.responseJSON && !!jqXHR.responseText) {
        const errorText = jQuery(jqXHR.responseText).find('[data-prop="errormessage-500"]').html();

        if (errorText && jQuery.trim(errorText).length > 0) {
          notify(jQuery.trim(errorText), 'danger');
        }
      }

      if (
        jqXHR.responseJSON &&
        !jqXHR.responseJSON.success &&
        jqXHR.responseJSON.errors &&
        Object.keys(jqXHR.responseJSON.errors).length > 0
      ) {
        Object.keys(jqXHR.responseJSON.errors).forEach(field =>
          notify(jqXHR.responseJSON.errors[field].message, 'danger'),
        );
      }

      if (options.complete) {
        options.complete(jqXHR, textStatus);
      }
    },
  });
}

export function post(options) {
  return request({ method: 'post', ...options });
}

export function get(options) {
  return request({ method: 'get', ...options });
}

export function getNonce(data) {
  try {
    if (typeof data === 'string' && jQuery.trim(data).substring(0, 1) === '{') {
      const response = JSON.parse(jQuery.trim(data));
      if (response.nonce) {
        return response.nonce;
      }
      if (response.NONCE) {
        return response.NONCE;
      }
    } else if (typeof data === 'string' && data.toLowerCase().indexOf('<html') !== -1) {
      const nonceRegex = new RegExp(/"NONCE":\s*"((\w|\W)+?)"/, 'g');
      const result = data.match(nonceRegex);
      if (!!result[1] && typeof result[1] === 'string') {
        return result[1];
      } else {
        const nonceInputValue = jQuery(data).find('[name="nonce"]').val();
        if (
          !!nonceInputValue &&
          typeof nonceInputValue === 'string' &&
          nonceInputValue.length > 0
        ) {
          return nonceInputValue;
        }
      }
    } else if (typeof data === 'string' && data.length < 120) {
      return data;
    }
  } catch (err) {}

  return null;
}

export function updateNonce(response) {
  const nonce = getNonce(response);

  if (nonce) {
    APP.NONCE = nonce;

    [...document.querySelectorAll('[name="nonce"]')].forEach(element => (element.value = nonce));
  }
}
